
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"64","width":"64"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"64","height":"64","ry":"8","fill":"#fff"}}),_c('rect',{attrs:{"width":"24","height":"8","x":"8","y":"8","ry":"4","fill":"#e00b5d"}}),_c('rect',{attrs:{"width":"48","height":"8","x":"8","y":"24","ry":"4"}}),_c('rect',{attrs:{"width":"32","height":"8","x":"8","y":"36","ry":"4"}}),_c('rect',{attrs:{"width":"40","height":"8","x":"8","y":"48","ry":"4"}})])
          )
        }
      }
    